/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WidgetOptions } from './WidgetOptions';
import {
    WidgetOptionsFromJSON,
    WidgetOptionsFromJSONTyped,
    WidgetOptionsToJSON,
    WidgetOptionsToJSONTyped,
} from './WidgetOptions';
import type { SecurityWidgetQueryRequestDateRange } from './SecurityWidgetQueryRequestDateRange';
import {
    SecurityWidgetQueryRequestDateRangeFromJSON,
    SecurityWidgetQueryRequestDateRangeFromJSONTyped,
    SecurityWidgetQueryRequestDateRangeToJSON,
    SecurityWidgetQueryRequestDateRangeToJSONTyped,
} from './SecurityWidgetQueryRequestDateRange';
import type { WidgetExclusions } from './WidgetExclusions';
import {
    WidgetExclusionsFromJSON,
    WidgetExclusionsFromJSONTyped,
    WidgetExclusionsToJSON,
    WidgetExclusionsToJSONTyped,
} from './WidgetExclusions';

/**
 * 
 * @export
 * @interface SecurityWidgetQueryRequest
 */
export interface SecurityWidgetQueryRequest {
    /**
     * 
     * @type {string}
     * @memberof SecurityWidgetQueryRequest
     */
    chartType?: string;
    /**
     * 
     * @type {string}
     * @memberof SecurityWidgetQueryRequest
     */
    metricKind?: string;
    /**
     * 
     * @type {SecurityWidgetQueryRequestDateRange}
     * @memberof SecurityWidgetQueryRequest
     */
    dateRange?: SecurityWidgetQueryRequestDateRange;
    /**
     * 
     * @type {Array<string>}
     * @memberof SecurityWidgetQueryRequest
     */
    visibleSeverities?: Array<string>;
    /**
     * 
     * @type {WidgetExclusions}
     * @memberof SecurityWidgetQueryRequest
     */
    exclusions?: WidgetExclusions;
    /**
     * 
     * @type {WidgetOptions}
     * @memberof SecurityWidgetQueryRequest
     */
    widgetOptions?: WidgetOptions;
}

/**
 * Check if a given object implements the SecurityWidgetQueryRequest interface.
 */
export function instanceOfSecurityWidgetQueryRequest(value: object): value is SecurityWidgetQueryRequest {
    return true;
}

export function SecurityWidgetQueryRequestFromJSON(json: any): SecurityWidgetQueryRequest {
    return SecurityWidgetQueryRequestFromJSONTyped(json, false);
}

export function SecurityWidgetQueryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityWidgetQueryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'chartType': json['chartType'] == null ? undefined : json['chartType'],
        'metricKind': json['metricKind'] == null ? undefined : json['metricKind'],
        'dateRange': json['dateRange'] == null ? undefined : SecurityWidgetQueryRequestDateRangeFromJSON(json['dateRange']),
        'visibleSeverities': json['visibleSeverities'] == null ? undefined : json['visibleSeverities'],
        'exclusions': json['exclusions'] == null ? undefined : WidgetExclusionsFromJSON(json['exclusions']),
        'widgetOptions': json['widgetOptions'] == null ? undefined : WidgetOptionsFromJSON(json['widgetOptions']),
    };
}

export function SecurityWidgetQueryRequestToJSON(json: any): SecurityWidgetQueryRequest {
    return SecurityWidgetQueryRequestToJSONTyped(json, false);
}

export function SecurityWidgetQueryRequestToJSONTyped(value?: SecurityWidgetQueryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'chartType': value['chartType'],
        'metricKind': value['metricKind'],
        'dateRange': SecurityWidgetQueryRequestDateRangeToJSON(value['dateRange']),
        'visibleSeverities': value['visibleSeverities'],
        'exclusions': WidgetExclusionsToJSON(value['exclusions']),
        'widgetOptions': WidgetOptionsToJSON(value['widgetOptions']),
    };
}

